import store from '../../store'

export function startUpload(uploadId) {
	store.dispatch({ type: 'START_UPLOAD', uploadId })
}


